import { defineMessages } from "react-intl"

export default defineMessages({
  heading: {
    id: "app.components.ContactUs.heading",
  },
})
